import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { businessInfo, logoUrl } from '../data/mock';

const Navigation = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navigation-header">
      <Link to="/" className="navigation-logo-container">
        <img src={logoUrl} alt="Joe's Appliance Installs Logo" className="logo-image" />
        <span className="navigation-logo">{businessInfo.name}</span>
      </Link>
      
      <ul className="navigation-menu">
        <li>
          <Link 
            to="/" 
            className={`navigation-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
        </li>
        <li>
          <Link 
            to="/services" 
            className={`navigation-link ${isActive('/services') ? 'active' : ''}`}
          >
            Services
          </Link>
        </li>
        <li>
          <Link 
            to="/about" 
            className={`navigation-link ${isActive('/about') ? 'active' : ''}`}
          >
            About
          </Link>
        </li>
        <li>
          <Link 
            to="/contact" 
            className={`navigation-link ${isActive('/contact') ? 'active' : ''}`}
          >
            Contact
          </Link>
        </li>
      </ul>

      <div className="navigation-utilities">
        <Link to="/contact" className="btn-primary nav-cta-button">
          Request a Quote
        </Link>
      </div>
    </nav>
  );
};

export default Navigation;
